import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateStaffComponent = loadable(
  () => import("../../components/Staff/CreateUser")
);
const CreateStaff = ({ setOpenUserFormPopup, openUserFormPopup }) => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["users"],
  });
  const { data: userProfile, isLoading } = useGetHook({
    url: `${APIS.USER}me/`,
    queryKey: ["user-profile"],
    params: {},
  });
  const handleCreateUser = async (values: any, setError: any) => {
    const url = `${APIS.USER}`;
    let formData = {
      ...values,
      is_staff: true,
    };
    try {
      await mutateAsync({ url, formData, setError });
      setOpenUserFormPopup(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {/* <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Staff
        </span>
      </div> */}
      <CreateStaffComponent
        userProfile={userProfile}
        isLoading={isPostLoading}
        handleCreateUser={handleCreateUser}
      />
    </>
  );
};

export default CreateStaff;
